
export const COLOR_PALETTE = {
    primary: '#003B6B',     
    primaryLight: '#0055A5', 
    primaryDark: '#002a4d',  
    secondary: '#6C757D',   
    accent: '#17A2B8',       
    success: '#28A745',      
    warning: '#FFC107',     
    danger: '#DC3545',     
    neutral: {
        50: '#F8F9FA',
        100: '#F3F4F6',
        200: '#E9ECEF',
        300: '#DEE2E6',
        400: '#CED4DA',
        500: '#ADB5BD',
        600: '#6C757D',
        700: '#495057',
        800: '#343A40',
        900: '#212529'
    }
};

export const EXPERT_COLORS = [
    '#003B6B', 
    '#17A2B8', 
    '#28A745', 
    '#6C757D',
    '#FFC107', 
    '#DC3545', 
    '#20C997', 
    '#6F42C1' 
];

export const CHART_COLORS = {
    sam: '#6F42C1',          
    crisp: '#28A745',        
    area: '#6F42C1',         
    grid: COLOR_PALETTE.neutral[200],
    axis: COLOR_PALETTE.neutral[500],
    tooltip: {
        bg: 'rgba(255, 255, 255, 0.95)',
        border: COLOR_PALETTE.neutral[300]
    }
};

export const MEMBERSHIP_TYPES = {
    TRIANGULAR: 'triangular',
    TRAPEZOIDAL: 'trapezoidal'
};

export const DEFUZZ_METHODS = {
    CENTROID: 'centroid', 
    MEDIAN: 'median'       
};

